import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    containerDoc:{
      height: '100%'
    }
  }
})